import { Button } from "@mui/material";
import { Link } from "react-router-dom";

const ProfileOrdersButton = () => (
  <Button
    component={Link}
    to="/profile/orders"
    sx={{
      mt: 3,
      width: "100%",
      py: 1.5,
      borderRadius: "10px",
      fontSize: "16px",
      fontWeight: 600,
      color: "#fff",
      background: "linear-gradient(135deg, #1E90FF, #007BFF)",
      textTransform: "none",
      transition: "0.3s",
      "&:hover": { background: "linear-gradient(135deg, #007BFF, #1E90FF)" },
    }}
  >
    История заказов
  </Button>
);

export default ProfileOrdersButton;
